import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c28b7558"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mfa-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please enter one of your recovery codes", -1))
const _hoisted_3 = { class: "white" }

import { computed, onBeforeMount, ref, onMounted, inject } from 'vue'
import { faKey } from 'fontawesome/free-solid-svg-icons'
import Typography from '@/components/Rain/Typography/Typography.vue'
import BasePillButton from '@/components/BasePillButton.vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { useRoute, useRouter } from 'vue-router'
import { loginAndRedirect } from '@/mobile/src/services/auth'
import SimpleSpinner from '@/components/SimpleSpinner.vue'
import { LoginMainPkey, LoginMainProvided } from '@/mobile/src/types/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'MFARecoveryCodeLogin',
  setup(__props) {

const recoveryCode = ref('')
const loading = ref(false)
const domain = ref('')

const route = useRoute()
const router = useRouter()

const enteredCode = computed(() => {
    return !!recoveryCode.value
})

const { credentials } = inject(LoginMainPkey) as LoginMainProvided

onBeforeMount(() => {
    domain.value = String(route.query.domain)
})

onMounted(async () => {
    if (
        !domain.value ||
        !credentials.value.email ||
        !credentials.value.password
    ) {
        await router.replace({
            name: 'findlogin',
            replace: true,
        })

        return
    }
})

async function verifyRecoveryCode() {
    loading.value = true
    await loginAndRedirect(
        domain.value,
        credentials.value.email,
        credentials.value.password,
        '',
        false,
        '',
        recoveryCode.value
    )
    loading.value = false
    recoveryCode.value = ''
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(FontAwesomeIcon), {
      class: "circle-icon",
      icon: _unref(faKey)
    }, null, 8, ["icon"]),
    _createVNode(Typography, {
      variant: "h4",
      component: "h4",
      class: "title-container"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Verify Recovery Code")
      ], undefined, true),
      _: 1
    }),
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recoveryCode).value = $event)),
      type: "text",
      class: "mfa-code-input",
      placeholder: "Your 12 digit code",
      maxlength: "13",
      onKeyup: _cache[1] || (_cache[1] = _withKeys(() => _ctx.$refs.verifyBtn.onClick(), ["enter"]))
    }, null, 544), [
      [_vModelText, recoveryCode.value]
    ]),
    _createVNode(BasePillButton, {
      ref: "verifyBtn",
      class: "verify-button",
      disabled: loading.value || !enteredCode.value,
      onClick: verifyRecoveryCode
    }, {
      default: _withCtx(() => [
        (loading.value)
          ? (_openBlock(), _createBlock(SimpleSpinner, {
              key: 0,
              size: "tiny",
              "line-bg-color": "transparent",
              "line-fg-color": _ctx.$palette.brandPurple
            }, null, 8, ["line-fg-color"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("SUBMIT")
            ], 64))
      ], undefined, true),
      _: 1
    }, 8, ["disabled"]),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(" Back to "),
      _createVNode(_component_RouterLink, {
        class: "find-login white",
        to: {
                    name: 'mfa-login',
                    params: {
                        domain: domain.value,
                        email: _unref(credentials).email,
                        password: _unref(credentials).password,
                    },
                },
        replace: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode("use MFA code ")
        ], undefined, true),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})